module.exports = __webpack_public_path__ + "img/colomn-icon.ce0df145.svg";